const faqResources = {
  en: {
    translation: {
      'FAQ title': 'FAQs (Frequently asked questions)',
      'FAQ1 title': 'Where can I see the insurance terms and conditions?',
      'FAQ1 text': 'All the terms and conditions can be found',
      'FAQ1 link': 'here',
      'FAQ2 title':
        'What do I do if I have been involved in a road traffic accident?',
      'FAQ2 text1':
        'In the event of an accident, take reasonable measures to minimize the potential for loss or damage and provide help to the injured parties;',
      'FAQ2 text2':
        'notify the competent authorities of the insured event and the persons involved (the traffic police, fire brigade, ambulance service, emergency services);',
      'FAQ2 text3':
        'Notify the Insurance Company immediately, but no later than three working days after the Insured Event.',
      'FAQ2 text4':
        'Notify the injured party and the traffic police of the name of the Insurance Company with which the Insurance Contract of Compulsory civil liability insurance for the owner of a motor vehicle has been concluded;',
      'FAQ2 text5':
        'Not later than two hours from the moment of receipt of a written referral from an authorized officer, undergo a medical examination to establish the fact of use of psychoactive substances and the state of intoxication under the requirements of the legislation of the Republic of Kazakhstan;',
      'FAQ2 text6':
        'Immediately, not later than two working days from the date of notification to the Insurance Company of the occurrence of the Insured Event, notify the injured party thereof;',
      'FAQ2 text7':
        'Provide the Insurance Company with a transfer of your right of recourse to the person responsible for the insured event.',
      'FAQ3 title': 'How much does insurance cost?',
      'FAQ3 text': 'You can instantly calculate the cost of insurance',
      'FAQ3 link': 'here',
      'FAQ4 title': 'How to become an agent?',
      'FAQ4 text': 'Easy! Register online and become part of our team!',
      'FAQ4 link': 'Register at',
    },
  },
  kz: {
    translation: {
      'FAQ title': 'Жиі қойылатын сұрақтар',
      'FAQ1 title': 'Сақтандыру шарттарын қайда қарап шыға аламын?',
      'FAQ1 text': 'Өнімдер бойынша барлық шарттарды осы жерден қарап шыға',
      'FAQ1 link': 'аласыз',
      'FAQ2 title': 'Егер жол-көлік оқиғасы болса, не істеймін?',
      'FAQ2 text1':
        'Көлік оқиғасын жасаған кезде ықтимал залалдар мен зиянды азайту үшін қалыптасқан мән-жайда қисынды шаралар қолданыңыз,  зардап шеккен адамдарға көмек көрсетіңіз;',
      'FAQ2 text2':
        'Сақтандыру жағдайы және зардап шеккен адамдар туралы тиісті органдарға ( жол полициясының қызметкерлеріне, өртке қарсы қызметке, жедел медициналық жәрдем қызметіне, апат қызметтеріне) хабарлаңыз;',
      'FAQ2 text3':
        'Тез арада, бірақ сақтандыру оқиғасы басталғаннан кейін үш жұмыс күнінен кешіктірмей Сақтандыру компаниясын хабардар етіңіз.',
      'FAQ2 text4':
        'Зардап шеккендерге және жол полициясы қызметкерлеріне көлік құралдары иелерінің жауапкершілігін міндетті сақтандыру шарты жасалған Сақтандыру компаниясының атауы хабарлаңыз;',
      'FAQ2 text5':
        'Уәкілетті лауазымды тұлғаның жазбаша жолдамасын алған сәттен бастап екі сағаттан кешіктірмей Қазақстан Республикасының заңнамасының талаптарына сәйкес психобелсенді құралдар қабылдау фактісін және масаю халін анықтау үшін медициналық куәландырудан өтіңіз;',
      'FAQ2 text6':
        'Тез арада, Сақтандыру компаниясына сақтандыру оқиғасы басталғаны туралы хабарлаған күннен бастап екі жұмыс күнінен кешіктірмей, бұл туралы зардап шеккен адамды хабардар етіңіз;',
      'FAQ2 text7':
        'Сақтандыру компаниясына сақтандыру оқиғасының басталғаны үшін жауапты адамға өзіңіздің кері талап ету құқығыңыздың ауысуын беріңіз.',
      'FAQ3 title': 'Сақтандырудың құны қанша?',
      'FAQ3 text': 'Сақтандырудың құнын Сіз лезде осы жерде есептей',
      'FAQ3 link': 'аласыз',
      'FAQ4 title': 'Қалай агент болуға болады?',
      'FAQ4 text':
        'Оңай! Онлайн тіркеуден өтіп, біздің тобымыздың бөлшегі болыңыз! ',
      'FAQ4 link': 'Тіркелу',
    },
  },
  ru: {
    translation: {
      'FAQ title': 'Часто задаваемые вопросы',
      'FAQ1 title': 'Где я могу посмотреть условия страхования?',
      'FAQ1 text': 'Все условия по продуктам можете посмотреть',
      'FAQ1 link': 'здесь',
      'FAQ2 title':
        'Что делать, если случилось дорожно-транспортное происшествие?',
      'FAQ2 text1':
        'При совершении транспортного происшествия, примите разумные в сложившихся обстоятельствах меры, чтобы уменьшить возможные убытки и вред, и окажите помощь пострадавшим лицам;',
      'FAQ2 text2':
        'Сообщите в соответствующие органы о страховом случае и пострадавших лицах (сотрудникам дорожной полиции, в противопожарную службу, в службу скорой медицинской помощи, аварийные службы);',
      'FAQ2 text3':
        'Незамедлительно, но не позднее трех рабочих дней, после наступления страхового случая, уведомите Страховую компанию.',
      'FAQ2 text4':
        'Сообщите потерпевшим и сотрудникам дорожной полиции наименование Страховой компании, с которой заключен договор обязательного страхования ответственности владельцев транспортных средств;',
      'FAQ2 text5':
        'Не позднее двух часов с момента получения письменного направления уполномоченного должностного лица, пройдите медицинское освидетельствование для установления факта употребления психоактивных веществ и состояния опьянения в соответствии с требованиями законодательства Республики Казахстан;',
      'FAQ2 text6':
        'Незамедлительно, не позднее двух рабочих дней со дня сообщения Страховой компании о наступлении страхового случая, уведомите об этом потерпевшего;',
      'FAQ2 text7':
        'Предоставьте Страховой компании переход своего права обратного требования к лицу, ответственному за наступление страхового случая.',
      'FAQ3 title': 'Сколько стоит страховка?',
      'FAQ3 text': 'Стоимость страховки Вы можете рассчитать моментально',
      'FAQ3 link': 'здесь',
      'FAQ4 title': 'Как стать агентом?',
      'FAQ4 text':
        'Легко! Пройдите онлайн регистрацию и станьте частью нашей команды!',
      'FAQ4 link': 'Регистрация',
    },
  },
};

export default faqResources;
